import React from "react"
import { Card, Icon } from "@mostlycode/ui"
import styled from "styled-components"
import Link from "../Link"
import Content from "../Content"

const StyledCase = styled(Card)`
  position: relative;
  padding: 0;
  line-height: 0;
  box-shadow: 0 20px 40px rgba(50, 50, 86, 0.25);
  background: ${(props) => props.theme.colors.white};
  border-radius: 5px;

  figure {
    overflow: hidden;
    margin: 0;
    clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 93%);
    border-radius: 5px 5px 0 0;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    & + & {
      margin-top: 0;
    }

    figure {
      clip-path: polygon(0 0, 100% 0%, 100% 100%, 0% 93%);
    }
  `}
`

const StyledContent = styled.div`
  padding: 2rem 2rem;

  h3 {
    margin: 0 0 0.5em;
  }

  p {
    margin-top: 0;
    margin-bottom: 0.5em;
    font-size: 1.6rem;
  }

  a {
    color: ${(props) => props.theme.colors.poppy};
    svg {
      width: 1.6rem;
      height: 1.6rem;
      transition: all ease-out 0.15s;
      transform: translate3d(0, 0, 0);
    }

    &:hover {
      color: currentColor;
      svg {
        transform: translate3d(0.5rem, -0.5rem, 0);
      }
    }
  }
`

function Case({ url, title, img, alt, summary, ...props }) {
  return (
    <StyledCase size="sm" {...props}>
      <figure>{img}</figure>
      <StyledContent>
        <Content content={title} />
        <Content content={summary} />
        <Link to={url} blank>
          Se websitet <Icon icon="external-link" size="auto" />
        </Link>
      </StyledContent>
    </StyledCase>
  )
}

export default Case

Case.defaultProps = {}
Case.propTypes = {}
